import { runInitialAssistantTurn } from '@/features/chat/runInitialAssistantTurn'
import { clearSend } from './sendInFlightGuard'

export function startInitialAssistantTurn(p) {
  const {
    tid,
    trimmed,
    files,
    signal,
    setMessagesByThreadId,
    connectContext,
    proposalId,
    researchMode,
    refinement,
    model,
    openStream,
    turn,
    sendInFlightRef,
    guard,
    onChatEvent,
  } = p
  runInitialAssistantTurn({
    tid,
    trimmed,
    files,
    signal,
    setMessagesByThreadId,
    connectContext,
    proposalId,
    researchMode,
    refinement,
    model,
    openStream,
    onChatEvent,
    ...turn,
    onSettled: () => clearSend(sendInFlightRef, guard),
  })
}
